<template>
  <div>
    <relevance v-if="configLoaded" />
    <settings-loader v-if="configLoaded" />
    <v-app v-if="!isLoaded || !configLoaded">
      <v-main>
        <v-container fluid>
          <v-row>
            <v-col class="text-center">
              <v-progress-circular color="loader" indeterminate size="50" width="7" />
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
    <router-view v-if="isLoaded && configLoaded" />

  </div>
</template>

<style>
/* для скрытия скролов таблиц*/
/* .v-icon.v-icon::after {
  content: none;
} */

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
   color: var(--v-textcolor-base)!important;
  /* margin-top: 60px; */
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: var(--v-textcolor-base)!important;
}
/*
#nav a.router-link-exact-active {
  color: #42b983;
} */

/* делаем по всему проекту текст и иконки потемнее */
/* .theme--light  {
  color: rgba(0,0,0,.75)!important;
} */
/* текст для заголовков, контролов ввода и просмотра данных делаем почти черным */
.v-label,
.theme--light.v-input .v-select__selection ,
.theme--light.v-label,
.theme--light.v-data-table thead tr th,
.theme--light.v-data-table tbody tr td,
.theme--light.v-list-item,
.theme--light.v-subheader,
.v-subheader.theme--light,
.theme--light.v-date-picker-header button,
.theme--light .v-data-footer,
.theme--light .v-btn:not(.theme--dark,.v-btn--disabled,.v-btn--rounded,.primary--text,.success--text,.accent--text,.warning--text,.error--text),
.theme--light input,
.theme--light .v-expansion-panel-header,
.theme--light .v-expansion-panel-header button,
.theme--light .v-stepper__step--active .v-stepper__label {
  color: var(--v-textcolor-base)!important;
}

/* .theme--light.v-icon, */
.theme--light.v-list--nav .theme--light.v-icon,
.theme--light.v-date-picker-table th,
/* .theme--light input, */
.theme--light .v-stepper__step--inactive .v-stepper__label {
  color: var(--v-inactiveitem-base)!important;
}
.theme--light .v-stepper__step--inactive .v-stepper__step__step {
  background: var(--v-inactiveitem-base)!important;
}
/* в контроле выбора дат красим текст в белый, если дата выбрана, и везде, где фон не белый(primary/error/success/accent) текст белый */

.v-toolbar.theme--light.primary span,
.v-toolbar.theme--light.primary,
.v-toolbar.theme--light.accent,
.v-toolbar.theme--light.warning,
.v-btn.theme--light.success,
.v-btn.theme--light.error,
.v-btn.theme--light.warning,
.v-btn.theme--light.primary,
.v-btn.theme--light.accent,
/* .v-btn.theme--light.v-btn--has-bg, */
.v-alert:not(.v-alert--outlined).error i,
.primary .theme--light,
.theme--light .v-alert:not(.v-alert--outlined),
.theme--light .v-alert:not(.v-alert--outlined) i {
  color: var(--v-textwithbackground-base)!important;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled,
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-btn,
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-icon
{
    color: hsla(0,0%,100%,.6);
}

/* .theme--dark.v-input .v-select__selection ,
.theme--dark.v-label,
.theme--dark.v-data-table thead tr th,
.theme--dark.v-data-table tbody tr td,
.theme--dark.v-list-item,
.theme--dark.v-subheader,
.v-subheader.theme--dark,
.theme--dark.v-date-picker-header button,
.theme--dark .v-data-footer,
.theme--dark .v-expansion-panel-header,
.theme--dark .v-expansion-panel-header button,
.theme--dark .v-stepper__step--active .v-stepper__label {
  color: var(--v-textcolor-base)!important;
}
.theme--dark.v-date-picker-table th,
.theme--dark input,
.theme--dark .v-stepper__step--inactive .v-stepper__label {
  color: var(--v-inactiveitem-base)!important;
}
.theme--dark .v-stepper__step--inactive .v-stepper__step__step {
  background: var(--v-inactiveitem-base)!important;
} */

/* в контроле выбора дат красим текст в белый, если дата выбрана, и везде, где фон не белый(primary/error/success/accent) текст белый */
/* .primary.theme--dark,
.accent.theme--dark,
.v-btn.theme--dark.success,
.v-btn.theme--dark.error,
.primary .theme--dark,
.theme--dark .orange  {
  color: var(--v-textwithbackground-base)!important;
} */
</style>

<script>

  import Relevance from '@/components/reused/layouts/Relevance.vue'
  import SettingsLoader from '@/components/reused/layouts/SettingsLoader.vue'
  import { mapState, mapActions } from 'vuex'
  import { SYSTEM_SETTINGS } from '@/constants/store.js'

  export default {
    components: {
      Relevance,
      SettingsLoader
    },
    computed: {
      ...mapState(SYSTEM_SETTINGS.NAMESPACE, {
        isLoaded: SYSTEM_SETTINGS.STATE.IS_LOADED,
        configLoaded: state => state[SYSTEM_SETTINGS.STATE.CONFIGURATION].loaded || false
      })
    },
    created () {
      // исправление для маршрутизации в IE (при переходе по ссылкам не обновляется компонент)
      // не удалять
      // https://github.com/vuejs/vue-router/issues/1849
      if ('-ms-scroll-limit' in document.documentElement.style &&
        '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
        window.addEventListener('hashchange', (event) => {
          const currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        }, false)
      }
      this.addFavIcon()
      this.getConfiguration()
    },
    beforeDestroy () {
      this.clearConfigurationAction()
    },
    methods: {
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        clearConfigurationAction: SYSTEM_SETTINGS.ACTIONS.CLEAR_CONFIGURATION
      }),
      addFavIcon: function () {
        var link = document.createElement('link')
        link.rel = 'icon'
        link.href = this.getSystemFileUrl('favicon.ico')
        document.head.appendChild(link)
      }
    }
  }
</script>
